import { Outlet, useLocation } from "react-router-dom";
import { SnowRail } from "./SnowRail";
import { Sidebar } from "./Sidebar";
import { SettingsModal } from "@/features/settings/SettingsModal";
import { UserProfileModal } from "@/features/profile/UserProfileModal";
import { CreateServerModal } from "@/features/servers/CreateServerModal";
import { useModalStore } from "@/store/modalStore";
import { useUIStore } from "@/store/uiStore";
import "./AppLayout.css";

export function AppLayout() {
  const location = useLocation();
  const isHome = location.pathname === "/app";
  const activeModal = useModalStore((s) => s.activeModal);
  const profileData = useModalStore((s) => s.profileData);
  const closeModal = useModalStore((s) => s.closeModal);
  const sidebarOpen = useUIStore((s) => s.sidebarOpen);
  const closeSidebar = useUIStore((s) => s.closeSidebar);

  const modals = (
    <>
      {activeModal === "settings" && <SettingsModal onClose={closeModal} />}
      {activeModal === "profile" && profileData && (
        <UserProfileModal
          userId={profileData.userId}
          displayName={profileData.displayName}
          username={profileData.username}
          createdAt={profileData.createdAt}
          isAdmin={profileData.isAdmin}
          onClose={closeModal}
        />
      )}
      {activeModal === "create-server" && <CreateServerModal onClose={closeModal} />}
    </>
  );

  if (isHome) {
    return (
      <div className="app-layout app-layout--home">
        <main className="app-layout__full">
          <Outlet />
        </main>
        {modals}
      </div>
    );
  }

  return (
    <div className="app-layout">
      <SnowRail />
      <div className="app-layout__body">
        <div className={`app-layout__sidebar-wrap${sidebarOpen ? " app-layout__sidebar-wrap--open" : ""}`}>
          <div className="app-layout__sidebar-overlay" onClick={closeSidebar} />
          <Sidebar />
        </div>
        <main className="app-layout__main">
          <Outlet />
        </main>
      </div>
      {modals}
    </div>
  );
}
